import React, { useState, useEffect, useCallback } from 'react'
import * as Yup from 'yup'
import moment from 'moment'
import { Formik, Form } from 'formik'
import { useSelector, useDispatch } from 'react-redux'
import { useModal } from 'react-modal-hook'
import Modal from '../../components/Modal/Modal'
import InputError from '../../components/InputError/InputError'
import NeoButton from '../../components/NeoButton/NeoButton'
import NeoInput from '../../components/NeoInput/NeoInput'
import NeoOTP from '../../components/FormComponents/NeoOTP'
import NeoSuccess from '../../components/FormComponents/NeoSuccess'
import { useHistory, useLocation } from 'react-router-dom'
import NumberFormat from 'react-number-format'
import NeoLoader from '../../components/FormComponents/NeoLoader'
import AccountDisplay from '../../components/account-display/account-display'
import { getCurrentAccDetailsSelector } from '../../store/selectors/app.selector'
import PaymentsService from '../../services/payments.service'
import LayoutWithAccountCard from '../Layout/layout-account-card'
import { setIsAcctRefresh } from '../../store/actions/app.actions'
import TermsAndCondition from '../../components/TermsAndConditions/TermsAndCondition'
import NotificationService from '../../services/notification.service'
import { BUTTON_KEYS, VALIDATION_KEYS, PAYMENT_KEYS } from '../../utils/translation-constants'
import { useTranslation } from 'react-i18next'
import validationConfig from 'custom/config/validation.config.json'
import QuickLinkService from '../../services/quick-link.service'
import { getRoleAccessKeySelector } from '../../selectors/app.selector'
const servicesConfig = validationConfig['payments']['services']

export default function TransferBillerProduct() {
  const location = useLocation()
  const [selectedBiller, setSelectedBiller] = useState({})
  const [productDetails, setProductDetails] = useState({ products: [] })
  const [selectedProduct, setSelectedProduct] = useState({
    amountLocalCur: '',
    amountType: '',
    name: '',
  })
  const history = useHistory()
  const dispatch = useDispatch()
  const [billers, setBillers] = useState([])
  const [quoteId, setQuoteId] = useState('')
  const [otp, setOTP] = useState('')
  const [stage, setStage] = useState(0)
  const [loading, setLoading] = useState(false)
  const [formValues, setFormValues] = useState(null)
  const [beneFormValues, setBeneFormValues] = useState({
    merchant: '',
    serviceNumber: '',
    shortName: '',
  })
  const srcAccountDetails = useSelector(getCurrentAccDetailsSelector)
  const [message, setMessage] = useState('Error Placeholder')
  const [randomKey, setRandomKey] = useState('')
  const [otpEnabled, setOtpEnabled] = useState(false)
  const [showBen, setShowBen] = useState(false)
  const [showBenList, setShowBenList] = useState([])
  const [zraAmount, setzraAmount] = useState(0)
  const [verifyDetails, setVerifyDetails] = useState({})
  const [error, setError] = useState({})
  const [requestValues, setRequestValues] = useState({})
  const { t } = useTranslation()
  const [data, setData] = useState({url:"",breadCrumb:""})
  const accessKey = useSelector(getRoleAccessKeySelector)
  const [successResponse, setSuccessResponse] = useState({})

  const LABELS = {
    BANKTOWALLET: t(PAYMENT_KEYS.MOBILE_NO),
  }

  const [showModal, hideModal] = useModal(
    () => (
      <Modal>
        <div className='modal-error-body'>
          <h6>{error?.message}</h6>
          <div className='modal-btn-style'>
            <NeoButton
              tabIndex='1'
              mode='newDesign'
              type='button'
              text={t(BUTTON_KEYS.OK)}
              onClick={() => {
                hideModal()
              }}
            />
          </div>
        </div>
      </Modal>
    ),
    [error],
  )

  useEffect(() => {
    location.pathname.includes('/transfers')&&setData({url:'/transfers',breadCrumb:'TRANSFERS_BILLER_SERVICE_FORM'})
    location.pathname.includes('/accounts') &&setData({url:'/accounts',breadCrumb:'ACCOUNTS_BILLER_SERVICE_FORM'})
    if (location.state === undefined) {
      history.push(`${data.url}/quick-pay`)
      return
    }
    // console.log(location?.state?.billerDetails)
    setSelectedBiller(location?.state?.billerDetails)
    getProductDetails()
    // getBillerBen(location?.state?.billerDetails)
  }, [])

  const getBillerBen = useCallback(async (data) => {
    try {
      setLoading(true)
      const response = await PaymentsService.getBillerBeneficiaries({
        merchant: data.merchant,
        serviceId: data.serviceId,
        serviceNumber: '',
        shortName: '',
      })
      if (response.status === 200) {
        setShowBenList(response.data['billerBeneficiary'])
        setLoading(false)
      }
    } catch (err) {
      // setMessage(err)
      // setError(err)
      // //showModal()
    }
  }, [])

  const getProductDetails = useCallback(async () => {
    try {
      const { billerDetails } = location?.state
      setLoading(true)
      const response = await PaymentsService.getServiceById({
        fetchProducts: true,
        serviceId: billerDetails.serviceId,
      })
      if (response.status === 200) {
        setProductDetails(response.data)
        // setShowBenList(response.data['billerBeneficiary'])
        setLoading(false)
      }
    } catch (err) {
      setMessage(err)
    }
  }, [])

  const setSelectedProductCallback = useCallback(
    (data) => {
      const selectedProductFull = productDetails.products.find(
        (value) => value.description === data,
      )
      setSelectedProduct(selectedProductFull)
    },
    [productDetails],
  )

  const onVerify = useCallback(
    async (data, { setSubmitting }) => {
      try {
        setLoading(true)
        setSubmitting(true)
        setFormValues(data)
        const reqParams = {
          amount: data.debitAmount,
          srcBranch: srcAccountDetails.brnCode,
          merchant: selectedBiller.merchantId || selectedBiller.description,
          productId: selectedProduct.productId || '',
          serviceId: productDetails.serviceId,
          serviceNumber: data.serviceNumber,
          srcAccount: srcAccountDetails.accountNo,
          srcCurrency: srcAccountDetails.currency,
          isFixed: selectedProduct?.amountType == 'FIXED' ? true : false,
          voucherType: productDetails.name || '',
          customerName: '',
          isScheduled: 'N',
          scheduledDate: '',
        }
        const response = await PaymentsService.getBillQuote(reqParams)
        if (response.status === 200) {
          setSubmitting(false)
          setLoading(false)
          setOtpEnabled(response.data['otpEnable'])
          setVerifyDetails(response.data)
          setRequestValues(reqParams)
          setStage(2)
        }
      } catch (err) {
        setSubmitting(false)
        setLoading(false)
      }
    },
    [selectedProduct, selectedBiller, srcAccountDetails],
  )

  const confirmPayment = useCallback(async () => {
    setLoading(true)
    try {
      const response = await PaymentsService.billPaymentInitiate({
        ...requestValues,
        quoteId: verifyDetails['quote']['quoteId'],
        otp: otp,
        randomKey: verifyDetails['randomKey'],
      })
      if (response.status === 200) {
        dispatch(setIsAcctRefresh(true))
        setSuccessResponse(response.data)
        setMessage(response.data['message'])
        setStage(4)
        setLoading(false)
      }
    } catch (err) {
      setLoading(false)
      setOTP('')
    }
    setLoading(false)
  }, [selectedBiller, selectedProduct, otp, srcAccountDetails, verifyDetails, requestValues])

  function renderSwitch() {
    switch (stage) {
      case 1:
        return renderPaymentForm()
      case 2:
        return renderConfirmation()
      case 3:
        return <NeoOTP otp={otp} setOTP={setOTP} onSubmit={confirmPayment} loading={loading} />
      case 4:
        return <NeoSuccess
          onClick1={async () =>
            await QuickLinkService.pdfReceipt({
              transRefNum: successResponse.referenceNo,
              refId: '',
              module: 'FUNDTRANSFER',
            })}
          module='DOWNLOAD_RECEIPT'
          roleKey={accessKey}
          message={message}
          linkPath='/transfers' />
      default:
        return renderPaymentForm()
    }
  }

  const ProductPaymentFormSchema = Yup.object().shape({
    serviceNumber:  Yup.string().required(
      `${LABELS[productDetails?.category] || t(PAYMENT_KEYS.SERVICE_NO)} ${t(
        PAYMENT_KEYS.IS_REQUIRED,
      )}`,
    ),
    amount: Yup.string().required(t(VALIDATION_KEYS.AMOUNT_REQUIRED)),
    remarks: Yup.string().required(t(VALIDATION_KEYS.REMARKS_REQUIRED)),
    product:
      productDetails.products.length > 0
        ? Yup.string().required(t(VALIDATION_KEYS.PRODUCT_REQUIRED))
        : Yup.string().optional(),
  })

  function renderPaymentForm() {
    return (
      <div className=''>
        <AccountDisplay currentAccountDetail={srcAccountDetails} />
        <Formik
          enableReinitialize
          initialValues={{
            serviceNumber: '',
            amount: selectedProduct ? selectedProduct.productAmount || '' : '',
            product: selectedProduct ? selectedProduct.description || '' : '',
            remarks: '',
            serviceNumberBen: '',
            showBen: false,
          }}
          validationSchema={ProductPaymentFormSchema}
          onSubmit={onVerify}>
          {({ isSubmitting, errors, touched, handleChange, values, setFieldValue }) => (
            <Form>
              <div>
                {productDetails.products.length > 0 && (
                  <div className='row'>
                    <div className='form-group col-12'>
                      <NeoInput
                        tabIndex='1'
                        showAsterisk={servicesConfig['isProductRequired']}
                        text={t(PAYMENT_KEYS.PRODUCT)}
                        mode='select'
                        name='product'
                        onChange={(e) => {
                          setSelectedProductCallback(e.target.value)
                          handleChange(e)
                          setFieldValue('amount', '')
                        }}
                        list={productDetails.products}
                        keyValue='description'
                      />
                      <InputError text={errors.product} touched={touched.product} />
                    </div>
                  </div>
                )}

                <div className='row'>
                  <div className='form-group col-12'>
                    <NeoInput
                      tabIndex='2'
                       text={LABELS[productDetails?.category] || t(PAYMENT_KEYS.SERVICE_NO)}
                      showAsterisk={servicesConfig['isServiceNumberequired']}
                      onChange={handleChange}
                      name='serviceNumber'
                      value={values.serviceNumber}
                    />
                    <InputError text={errors.serviceNumber} touched={touched.serviceNumber} />
                  </div>

                  <div className='form-group col-12'>
                    <NeoInput
                      tabIndex='3'
                      showAsterisk={servicesConfig['isAmountRequired']}
                      text={t(PAYMENT_KEYS.AMOUNT)}
                      name='amount'
                      onChange={(values) => {
                        setFieldValue('debitAmount', values.value)
                      }}
                      mode='amount'
                      value={values.amount}
                      disabled={selectedProduct.amountType === 'FIXED'}
                    />
                    <InputError text={errors.amount} touched={touched.amount} />
                  </div>
                </div>

                <div className='row'>
                  <div className='form-group col-12'>
                    <NeoInput
                      tabIndex='4'
                      showAsterisk={servicesConfig['isRemarksRequired']}
                      text={t(PAYMENT_KEYS.REMARKS)}
                      onChange={(e) => {
                        handleChange(e)
                      }}
                      name='remarks'
                      value={values.remarks}
                    />
                    <InputError text={errors.remarks} touched={touched.remarks} />
                  </div>
                </div>
                <div className='row'>
                  <div className='form-group col-12'>
                    {loading ? (
                      <NeoLoader />
                    ) : (
                      <NeoButton
                        tabIndex='5'
                        type='submit'
                        mode='newDesign'
                        disabled={loading}
                        text={t(BUTTON_KEYS.SUBMIT)}
                      />
                    )}
                  </div>
                </div>
                <div className='back-cancel-btn-container'>
                <button tabIndex={'6'} className='back-cancel-btn btn btn-sm new-design-warning-text-color' onClick={() => history.push(data.url)}>
                  {t(BUTTON_KEYS.CANCEL)}
                </button>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    )
  }

  function renderConfirmation() {
    return (
      <div>
        <div className='d-flex flex-column confirmation'>
          <AccountDisplay currentAccountDetail={srcAccountDetails} />
          <div>
            <h6 className='label'>{t(PAYMENT_KEYS.BILLER_NAME)}</h6>
            <h6 className='value'>{selectedBiller.merchantId}</h6>
          </div>
          <div>
          <h6 className='label'>
              {LABELS[productDetails?.category] || t(PAYMENT_KEYS.SERVICE_NO)}
            </h6>
            <h6 className='value'>{formValues.serviceNumber}</h6>
          </div>
          <div>
            <h6 className='label'>{t(PAYMENT_KEYS.CUSTOMER_NAME)}</h6>
            <h6 className='value'>{verifyDetails['quote']['customerName'] || '-'}</h6>
          </div>
          <div>
            <h6 className='label'>{t(PAYMENT_KEYS.CUSTOMER_ADDRESS)}</h6>
            <h6 className='value'>{verifyDetails['quote']['customerAddress'] || '-'}</h6>
          </div>
          <div>
            <h6 className='label'>{t(PAYMENT_KEYS.QUOTE_ID)}</h6>
            <h6 className='value'>{verifyDetails['quote']['quoteId']}</h6>
          </div>
          <div>
            <h6 className='label'>{t(PAYMENT_KEYS.AMOUNT_DUE)}</h6>
            <h6 className='value'>{verifyDetails['quote']['amountDue'] || '0'}</h6>
          </div>

          <div>
            <h6 className='label'>{t(PAYMENT_KEYS.AMOUNT)}</h6>
            <h6 className='value'>
              <NumberFormat
                value={formValues.amount}
                displayType={'text'}
                thousandSeparator={true}
                prefix={''}
                fixedDecimalScale={true}
                decimalScale={2}
                allowEmptyFormatting
              />
            </h6>
          </div>

          <div>
            <h6 className='label'>{t(PAYMENT_KEYS.REMARKS)}</h6>
            <h6 className='value'>
              {formValues.remarks === 'Custom' ? formValues.customRemarks : formValues.remarks}
            </h6>
          </div>

          <div>
            <TermsAndCondition module="BANKTOWALLET" />
          </div>
          <div className='mt-3 form-group col-12'>
            {loading ? (
              <NeoLoader />
            ) : (
              <NeoButton
                type='button'
                text={t(BUTTON_KEYS.CONFIRM)}
                mode='newDesign'
                onClick={async () => {
                  otpEnabled ? setStage(3) : await confirmPayment()
                }}
              />
            )}
          </div>
          <div className='back-cancel-style' onClick={() => setStage(1)}>
            {t(BUTTON_KEYS.BACK)}
          </div>
        </div>
      </div>
    )
  }

  return (
    <LayoutWithAccountCard 
    pageTitle={`${selectedBiller?.merchantId}- ${selectedBiller?.description}`}
    breadCumKey={data.breadCrumb}>
      <div className='new-design-form-style'>
        <div className='heading-style'>
          {selectedBiller?.merchantId}- {selectedBiller?.description}
        </div>
        {renderSwitch()}
      </div>
      </LayoutWithAccountCard>
  )
}
